import {lazy} from '@aboutyou/lazy-imports';

export const UnlockCouponInfo = lazy(() =>
  import('./UnlockCouponInfoGate').then(mod => ({
    default: mod.UnlockCouponInfo,
  })),
);
